var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_c('span',{staticClass:"steps__color--xuhao",style:({
      color: _vm.currentColor ? '#fff' : '#6D7278',
      background: _vm.currentColor,
      'border-color': _vm.currentColor,
    })},[_vm._v("01")]),_c('span',{staticClass:"steps__color--text",style:({ color: _vm.currentColor, 'border-color': _vm.currentColor })},[_vm._v("上传")]),_c('span',{staticClass:"steps__color--line",style:({ color: _vm.currentColor, 'border-color': _vm.currentColor })}),_c('span',{staticClass:"steps__color--xuhao",style:({
      color: _vm.currentColor ? '#fff' : '#6D7278',
      background: _vm.currentColor,
      'border-color': _vm.currentColor,
    })},[_vm._v("02")]),_c('span',{staticClass:"steps__color--text",style:({ color: _vm.currentColor, 'border-color': _vm.currentColor })},[_vm._v("压缩")]),_c('span',{staticClass:"steps__color--line",style:({ color: _vm.currentColor, 'border-color': _vm.currentColor })}),_c('span',{staticClass:"steps__color--xuhao",style:({
      color: _vm.currentColor ? '#fff' : '#6D7278',
      background: _vm.currentColor,
      'border-color': _vm.currentColor,
    })},[_vm._v("03")]),_c('span',{staticClass:"steps__color--text",style:({ color: _vm.currentColor, 'border-color': _vm.currentColor })},[_vm._v("下载")])])
}
var staticRenderFns = []

export { render, staticRenderFns }